import { Navigate } from "react-router-dom";
import { useUserRole } from "@/hooks/useUserRole";
import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";

export function AdminRoute({ children, requireAdmin = false }: { children: React.ReactNode; requireAdmin?: boolean }) {
  const { user, loading: authLoading } = useAuth();
  const { isAdmin, isStaff, loading } = useUserRole();

  if (authLoading || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) return <Navigate to="/partners/login" replace />;
  if (requireAdmin && !isAdmin) return <Navigate to="/partners/portal" replace />;
  if (!isStaff) return <Navigate to="/partners/portal" replace />;

  return <>{children}</>;
}
